import * as React from "react"
import { cn } from "@/lib/utils"

export interface BoxProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
}

const Box = React.forwardRef<HTMLDivElement, BoxProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "bg-[#0F1629] rounded-xl border border-gray-800/50 p-6",
          className
        )}
        {...props}
      >
        {children}
      </div>
    )
  }
)

Box.displayName = "Box"

export { Box }
